/*
//THIS CODE SNIPPET IS THE BASIC ALGORITHM FOR THE FRONT ENDS TO DETERMINE WHICH BUNDLE IS SELECTED

*****
There is a gap because user has drop down to see the bundles, when they select a bundle, you apply the
snippet source enums (which they have access to) to the settings for the current conversation.  That
part should work fine.)
The problem is that when you call get settings, you only get the snippet source enum list back, you
do not get which bundle it was from, so when user goes to a previous chat, you won't know which drop down bundle to select
for that chat.

This algorithm will tell you which bundle drop down to select.

****

//BUNDLES ROLE-UP SNIPPET SOURCE ENUMS

//SO THE CONFIGURATION STRUCTURE COMING FROM THE CHAT API IS LIKE THIS

{
 "data": [
    {
      "snippetSource": "string",
      "displayName": "string",
      "adGroupId": "string",
      "adGroupIds": [
        "string"
      ]
    }
  ],
  "bundle": [
    {
      "bundleName": "string",
      "snippetSources": [
        "string"
      ],
      "adGroupIds": [
        "string"
      ]
    }
  ],
  "defaultBundleName": "string"
}

example = {

    "data" : [
        {"snippetSource": "enumA","adGroupIds":["Grp1","Grp2","Grp3"]},
        {"snippetSource": "enumB","adGroupIds":["Grp77"]},
        {"snippetSource": "enumPerson","adGroupIds":[]},
        {"snippetSource": "enumGlobal","adGroupIds":[]},
    ]
    "bundle": [
        {"bundleName": "German","adGroupIds":["Grp1","Grp2","Grp3"]}, "snippetSources" : ["enumA","enumPerson"]},
        {"bundleName": "RnD","adGroupIds":["Grp94XX33"]}, "snippetSources" : ["enumB","enumGlobal","enumPerson"]},
        {"bundleName": "Global","adGroupIds":[]}, "snippetSources" : ["enumGlobal","enumPerson"]},

    ],
    "defaultBundleName": "enumGlobal"

}

IN THE CODE BELOW, THE VARIABLES allowed_snippet_source_enums,allowed_bundle_configurations
ARE AFTER YOU HAVE REMOVED THE ONES WHICH THE USER DOESN'T HAVE ACCESS TO BASED ON THE adGroupIds

*/

//RETURNS "DEFAULT" MEANING IT CAN'T FIGURE OUT WHICH BUNDLE IS SELECTED - there is a default bundle
export const whichBundleSelected = (
    selectedEnumList: Array<string>,
    allowed_snippet_source_enums: Array<string>,
    allowed_bundle_configurations: Array<{ bundle: string; enums: Array<string> }>,
) => {
    for (const x of selectedEnumList) {
        if (false == allowed_snippet_source_enums.includes(x)) return 'DEFAULT'
    }
    const number_per_bundle = []
    for (const x of allowed_bundle_configurations) {
        let count: number = 0
        let selectedEnumNotInBundle = false
        for (const s of selectedEnumList) {
            if (x.enums.includes(s)) {
                count = count + 1
            } else {
                selectedEnumNotInBundle = true
            }
        }
        if (selectedEnumNotInBundle) {
            //it is 100% not the right bundle if a enum is selected which is not in the bundle
            count = 0
        }
        number_per_bundle.push({ bundle: x.bundle, count: count })
    }

    let max_count: number = 0
    for (const x of number_per_bundle) {
        if (x.count > max_count) {
            max_count = x.count
        }
    }

    if (max_count == 0) {
        //no bundle matches selected enums
        return 'DEFAULT'
    }

    let count_of_max_count: number = 0
    for (const x of number_per_bundle) {
        if (x.count == max_count) {
            count_of_max_count = count_of_max_count + 1
        }
    }
    if (count_of_max_count != 1) {
        //for sure count_of_max_count is at least 1, but if there are 2 bundles that match the same count, then it is indeterminate
        return 'DEFAULT'
    }

    for (const x of number_per_bundle) {
        if (x.count == max_count) {
            return x.bundle
        }
    }

    return 'DEFAULT' //should never reach here
}
